// const AdminConfig = 'http://development.delasoft.com:8443/UPA-adminconfig'
// const Admin = 'http://development.delasoft.com:8443/UPA-admin'
 
import { getEnvVariable } from "../../../modules/environmentalList"
const NewAnnouncements = {
   "type": "popup",
   "key": "NewAnnouncements",
   "name": "NewAnnouncements",
   anchor: 'right',
   open: false,
   aliases: {
       open: 'addOpen'
   },
   sharedValues: ['open'],
   container: {
       values: { save: false, back: false, fullscreen: false, },
       mapValues: {
           header: [
               { key: 'exitfullscreen', name: 'exitfullscreen' },
               { key: 'fullscreen', name: 'fullscreen' },
           ],
           Announcements: [{ key: 'save', name: 'save' },
           { key: 'exitfullscreen', name: 'exitfullscreen' },
           { key: 'fullscreen', name: 'fullscreen' },]
       },
       //  sharedValues: ['save', 'edit'],
       mapActionsToEffects: {},
       layout: {
           group: [{
               order: 0,
               type: 'div',
               className: '',
               components: [{
                   name: 'header',
                   type: 'div',
                   className: 'col-12 px-1',
                   sub: {
                       type: 'div',
                       className: 'col-12 px-1',
                   }
               }],
           },
 
           {
               order: 1,
               type: 'div',
               className: 'row m-1 application-border',
               components: [{
                   name: 'Announcements',
                   type: 'div',
                   className: 'col-12',
                   sub: {
                       type: 'div',
                       className: 'col-12',
                   }
               }],
           },
           ]
       },
       components: {
           header: {
               name: "header",
               type: 'header',
               title: 'Announcements',
               components: [
                   {
                       type: 'breadcrumbs',
                       items: [
                           { "link": "Add Announcements", "materialicon": "campaign", className: 'eps-breadcrumb-item ', class: 'text-light' },
                       ]
                   }
               ],
               layout: {},
               actions: [
                   {
                       type: 'icon',
                       icon: 'back',
                       name: 'back',
                       hideon: 'back',
                       hidevalue: false,
                       title: 'Back'
                   },
                   {
                       type: 'icon',
                       icon: 'save',
                       name: 'save',
                       hideon: 'save',
                       hidevalue: false,
                       title: 'Save'
                   },
                   {
                       type: 'icon',
                       icon: 'fullscreen',
                       name: 'fullscreen',
                       hidevalue: false,
                       title: 'Full Screen'
                   },
                   {
                       type: 'icon',
                       icon: 'exitfullscreen',
                       name: 'exitfullscreen',
                       hideon: 'fullscreen',
                       hidevalue: false,
                       title: 'Exit Full Screen'
                   }
               ],
 
           },
           Announcements: {
               "type": "form",
               "key": "Announcements",
               "name": "Announcements",
               aliases: {
                   save: 'save',
               },
               "routeParams": { replace: 'announcements', param: 'Id', routeName: 'id' },
               sharedValues: ['save', 'back', 'exitfullscreen', 'fullscreen'],
               layout: {
                   group: [
                       {
                           order: 0,
                           type: 'div',
                           className: 'row',
                           components: [{
                               name: 'Subject',
                               type: 'div',
                               className: 'col-10',
                               sub: {
                                   type: 'div',
                                   className: 'col-10',
                               }
                           }],
                       },
                       {
                           order: 1,
                           type: 'div',
                           className: 'row',
                           components: [{
                               name: 'Body',
                               type: 'div',
                               className: 'col-10',
                               sub: {
                                   type: 'div',
                                   className: 'col-10',
                               }
                           },
 
                           ]
                       },
                        {
                           order: 2,
                           type: 'div',
                           className: 'row',
                           components: [{
                               name: 'ViewerAccess',
                               type: 'div',
                               className: 'col-10',
                               sub: {
                                   type: 'div',
                                   className: 'col-10',
                               }
                           },
 
                           ]
                       },
                       {
                           order: 3,
                           type: 'div',
                           className: 'row',
                           components: [
                               {
                                   name: 'Status',
                                   type: 'div',
                                   className: 'col-10 mt-2',
                                   sub: {
                                       type: 'div',
                                       className: 'col-10 mt-2'
                                   }
                               },
                           ]
                       },
                       // {
                       //     order: 3,
                       //     type: 'div',
                       //     className: 'row',
                       //     components: [{
                       //         name: 'IsViewable',
                       //         type: 'div',
                       //         className: 'col-6 m-2',
                       //         sub: {
                       //             type: 'div',
                       //             className: 'col-6 m-2'
                       //         }
                       //     },
                       //     ]
                       // },
                   ],
               },
               values: {
                   Subject: '',
                   Body: '',
                   ViewerAccess: 'B',
                   Status: 'N',
                   // IsViewable: 'N',
                   // portal: getEnvVariable('AccessPortal')
               },
               "components": {
                   Subject: {
                       "type": "textfield",
                       "key": "Subject",
                       "label": "Subject",
                       "name": "Subject",                  
                   },
                   Body: {
                       "type": "editor",
                       "key": "Body",
                       "label": "Body",
                       "name": "Body",
                       "multiline": true,
                       rowsMax: "5",
                       "rows": 6,
                        "editorProps": {
    height: 250,
    toolbar: [
      'bold', 'italic', 'underline', 'strike', 'link', 'image', 'code', 'list', 'bullet', 'blockquote', 'clean'
    ]
  }
                   },
                   ViewerAccess: {
                        "type": "radiogroup",
                        "key": "ViewerAccess",
                        "label": "Viewer Access",
                        name: "ViewerAccess",
                        // custom: true,
                        extraProps: {
                            transformProps: {
                                label: 'name',
                                value: 'value'
                            },
                        },
                        items: [{ value: 'I', name: 'Internal' }, { value: 'E', name: 'External' }, { value: 'B', name: 'Both' }],
                    },
                    Status: {
                       "type": "toggle",
                       "key": "Status",
                       "label": "Status",
                       "name": "Status",
                       disabled: true,
                                   conditions: {
                                       enable: true,
                                   },
                       extraProps: {
                           transformProps: {
                               I: false,
                               A: true,
                               'true': 'A',
                               'false': 'I'
                           },
                       }
                   },
                   // IsViewable: {
                   //     "type": "checkbox",
                   //     "key": "IsViewable",
                   //     "label": "Can be Viewed by Applicant",
                   //     "name": "IsViewable",
                   //     extraProps: {
                   //         transformProps: {
                   //             N: false,
                   //             Y: true,
                   //             'true': 'Y',
                   //             'false': 'N'
                   //         },
                   //     }
                   // },
               },
               mapActionsToEffects: {
                //    'onLoad': {
                //        init: {
                //            rules: [{
                //                run:
                //                {
                //                    valid: [                                    
                //                        {
                //                            type: 'validations', //http://development.delasoft.com:8443/AMES-application/api/ProposedLandUse/5864/Add
                //                            "read": [
                //                                {
                //                                   "url": getEnvVariable('Admin')+`/api/Announcements/Add`,
                //                                    type: 'get'
                //                                }
                //                            ],
                //                         //    transformProps: {
                //                         //        removesubfieldname: 'SHAPESMODULEMASTER.ANNOUNCEMENTS_'
                //                         //    }
                //                        },
                //                     //    {
                //                     //        type: 'businessrules',
                //                     //        "read": [
                //                     //            {
                //                     //                url: getEnvVariable('Sidebar') + `/api/BusinessRules/Grid/modulemaster.notes`,
                //                     //                type: 'get',
                //                     //            }
                //                     //        ],
                //                     //    },
                //                    ]
                //                }
                //            },
                //         //    {
                //         //        check: [
                //         //            {
                //         //                condition: 'OR',
                //         //                rules: [
                //         //                    {
                //         //                        "name": "portal",
                //         //                        "type": "=",
                //         //                        "value": "E",
                //         //                        "rules": []
                //         //                    },
                //         //                ]
                //         //            }
                //         //        ],
                //         //        uncheck: true,
                //         //        run: {
                //         //            valid: [
                //         //                {
                //         //                    type: 'prop',
                //         //                    name: 'IsViewable',
                //         //                    isVisible: false
                //         //                },
                //         //            ],
                //         //            inValid: [
                //         //                {
                //         //                    type: 'prop',
                //         //                    name: 'IsViewable',
                //         //                    isVisible: true
                //         //                },
                //         //            ]
                //         //        }
                //         //    },
                //            ]
                //        },
                //        'exitfullscreen': {
                //            rules: [
                //                {
                //                    run: {
                //                        valid: [
                //                            {
                //                                type: 'exitfullscreen',
                //                            },
                //                        ]
                //                    }
                //                }
                //            ]
                //        },
                //        'fullscreen': {
                //            rules: [
                //                {
                //                    run: {
                //                        valid: [
                //                            {
                //                                type: 'fullscreen',
                //                            },
                //                        ]
                //                    }
                //                }
                //            ]
                //        },
                //    },
                   'afterSave': {
                       'save': {
                           rules: [
                               {
                                   run: {
                                       valid: [
                                           {
                                               type: 'save',// http://development.delasoft.com:8443/AMES-application/api/Property/23123/Add
                                               "read": [
                                                   {
                                                       "url": getEnvVariable('Admin')+`/api/Announcements/Add`,
                                                       type: 'post',
                                                    //    "matchProps": [{
                                                    //        name: "routeid1",
                                                    //        key: "routeid1",
                                                    //    }]
                                                   }
                                               ],
                                           },
                                           {
                                               type: 'value',
                                               key: 'addOpen',
                                               result: false
                                           },
                                       ]
                                   }
                               }
                           ]
                       },
                   }
               }
           }
       },
   }
}
export default NewAnnouncements